import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do dog trainers get more clients?",
    "a": "Program-specific pages plus video proof plus reviews. Owners search by program ('board and train', 'puppy class', 'aggressive dog'). Trainers who rank for each program book the right clients."
  },
  {
    "q": "Is SEO worth it for a dog trainer?",
    "a": "Yes — 'dog trainer near me' has stable, high-intent volume. One board-and-train client at $3k–$8k covers months of SEO."
  },
  {
    "q": "Should dog trainers run Google Ads?",
    "a": "Yes for board-and-train and behavior modification — high tickets justify CPCs. For group classes, SEO and Instagram drive more value."
  },
  {
    "q": "How do I attract owners who match my method?",
    "a": "Your method belongs on the site, in video, with owner testimonials. Owners self-select before they fill out the form. Bad fits drop off; good ones book."
  },
  {
    "q": "Do you market K9 schools and protection programs?",
    "a": "Yes — protection sport, personal protection, and detection work are great niches with low competition and high search intent."
  }
];

export const Route = createFileRoute("/dog-trainer-marketing-colorado")({
  head: () =>
    industryMarketingHead("Dog Trainer", "dog trainer or K9 school", "dog-trainer-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Dog Trainer"}
      industryLower={"dog trainer or K9 school"}
      slug={"dog-trainer-marketing-colorado"}
      subheadline={"We help Colorado dog trainers and K9 schools — from puppy classes to protection programs — fill the roster with the right owners."}
      painPoints={["Facebook and Instagram bring tire-kickers, not serious clients","Your training method is different but your site sounds like everyone else's","Board-and-train spots go empty for weeks at a time"]}
      serviceDescriptions={{
        seo: "Rank for puppy training, board-and-train, protection, behavior modification, and every program in every Colorado market.",
        googleMaps: "Own 'dog trainer near me' in the Map Pack with reviews that prove your method works.",
        webDesign: "Program-specific sites with video proof, owner testimonials, and clear pricing that filters bad-fit clients.",
        ppc: "Profitable Google Ads tuned to high-ticket board-and-train and behavior modification searches.",
        geoAi: "Get cited when owners ask ChatGPT 'best dog trainer in Denver' or 'K9 training near me'.",
        socialMedia: "Method-led video content that builds authority and pre-sells your training philosophy.",
      }}
      testimonial={{"quote":"Board-and-train is booked out two months and we attract owners who actually want to do the work. The roster quality changed completely.","role":"Head Trainer","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Dog trainer marketing in Colorado Springs","description":"Reach serious dog owners across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Dog trainer marketing in Denver","description":"Compete in Denver's crowded dog training market with the right roster."},{"to":"/boulder-digital-marketing","label":"Dog trainer marketing in Boulder","description":"Premium and behavior-focused training for Boulder's engaged owner base."}]}
    />
  ),
});
